import { FC } from 'react';

import {
  $AmountCell,
  PanelBodyLine,
} from '@savgroup-front-common/core/atoms/Panel/PanelBodyLine';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import getSparePartConditionMessage from '@savgroup-front-common/core/formatters/getSparePartConditionMessage';
import { formatReverseMoneyToString } from '@savgroup-front-common/core/formatters/intl';

interface NonOwnerRecipientSparePartQuotationLineProps {
  sparePartQuotationLine: any;
}

const NonOwnerRecipientSparePartQuotationLine: FC<
  NonOwnerRecipientSparePartQuotationLineProps
> = ({ sparePartQuotationLine }) => {
  return (
    <PanelBodyLine
      key={sparePartQuotationLine.id}
      isActive
      gridTemplateColumns={
        sparePartQuotationLine.recommendedSalePriceIncludingTaxes
          ? '6fr 4fr 2fr'
          : '10fr 2fr'
      }
    >
      <div>
        {[
          sparePartQuotationLine.manufacturerLabel,
          sparePartQuotationLine.subCategory,
          sparePartQuotationLine.supplierReference,
        ]
          .filter((x) => !!x)
          .join(' - ')}
      </div>
      <div>
        {sparePartQuotationLine.condition && (
          <SafeFormattedMessageWithoutSpread
            message={getSparePartConditionMessage(
              sparePartQuotationLine.condition,
            )}
          />
        )}
      </div>
      {sparePartQuotationLine.recommendedSalePriceIncludingTaxes && (
        <$AmountCell>
          {formatReverseMoneyToString({
            amount: 0,
            currency:
              sparePartQuotationLine.recommendedSalePriceIncludingTaxes
                .currency,
          })}
        </$AmountCell>
      )}
    </PanelBodyLine>
  );
};

export default NonOwnerRecipientSparePartQuotationLine;
